<template>
  <!--TODO: custom slider  -->

  <section
    id="reviews"
    class="flex flex-col items-center justify-center bg-[#fff8ee]"
  >
    <img src="@/assets/office.png" data-aos="zoom-out" data-aos-delay="1000" alt="Bezpečné a vstřícné prostředí k psychoterapii" class="image w-full hidden" />

    <swiper
      :spaceBetween="30"
      :centeredSlides="true"
      :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
      }"
      :pagination="{
        clickable: true,
      }"
      :modules="modules"
      class="mySwiper mb-10"
    >
      <swiper-slide v-for="(review, index) in reviews" :key="index">
        <p class="mx-10 my-20 max-w-4xl text-center text-xl leading-[30px]" data-aos="fade">
          {{ review.text }}
          <br />
          <br />
          <span class="text-[16px] text-primary font-semibold">– {{ review.person }}</span>
        </p>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
  data() {
    return {
      reviews: [
        {
          text: "„Nevěřila jsem, že mi můžete v mém zármutku pomoci. Po vašem setkání cítím velikou úlevu. Jste skvělá! Děkuji.“",
          person: "Jana",
        },
        {
          text: "„Moc Vám děkujeme za Vaši péči. Myslíme si že bez Vaší pomoci bychom náš vztah vzdali. Ještě jednou děkujeme.“",
          person: "Petra & Jan",
        },
        {
          text: "„Jsem moc ráda, že s Vámi můžeme sdílet těžkou životní situaci. Děkujeme za podporu a provázení.“",
          person: "Ondra & Olga",
        },
      ],
    };
  },
};
</script>

<style scoped>
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  background: #fff8ee;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

